import moment from "moment";

// Filter mapping for URL query params
export const getQueryFilterMap = (query) => {
  const filterMap = {
    "todays-follow-up-date": {
      followup_date_from: moment().format("YYYY-MM-DD"),
      followup_date_to: moment().format("YYYY-MM-DD"),
    },
    "todays-invoice-payments": {
      payment_date_from: moment().format("YYYY-MM-DD"),
      payment_date_to: moment().format("YYYY-MM-DD"),
    },
  };
  return filterMap[query] || null;
};
